import { Box } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import CustomTabsTable from "../global/CustomTabsTable";

const CNTSTable = ({ initialAssets }) => {
  const [currentTab, setCurrentTab] = useState("top");
  const [assets, setAssets] = useState(initialAssets || []);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        return (
          <Box
            key={params.id}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={params.row.logo}
              alt="logo"
              style={{ width: "25px", height: "25px", marginRight: "10px" }}
            />
            <Box>
              <Link
                to={`/cnts/${params.row.coingeckoId}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {params.formattedValue}
              </Link>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "totalVolume",
      headerName: "Total Volume",
      type: "number",
      headerAlign: "center",
      align: "center",
      valueFormatter: (value) => {
        return value.value.toLocaleString(undefined, {
          maximumFractionDigits: 0,
        });
      },
      flex: 1,
    },
  ];

  const handleTabChange = (newTab) => {
    setCurrentTab(newTab);
  };

  const tabsFunctions = {
    top: {
      func: function (data) {
        return data;
      },
      label: "Top",
      color: "default",
      sortModel: [
        {
          field: "totalVolume",
          sort: "desc",
        },
      ],
    },
  };

  return (
    <CustomTabsTable
      data={assets}
      columns={columns}
      name={"Assets"}
      tabs={tabsFunctions}
      defaultValue={"top"}
      sortModel={tabsFunctions.top.sortModel}
      onTabChange={handleTabChange}
    />
  );
};

export default CNTSTable;
